module.exports = __webpack_public_path__ + "img/appQrcode.25e2069c.jpg";